// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.primary-color i {
  color: #94a3b8;
}
/*# sourceMappingURL=manage-documents.component.css.map */`, "",{"version":3,"sources":["webpack://./manage-documents.component.less","webpack://./src/app/documents/manage-documents/manage-documents.component.less"],"names":[],"mappings":"AAEA;EAEI,cAAA;ACFJ;AACA,yDAAyD","sourcesContent":["@import (reference) \"../../../assets/less/colors.less\";\n\n.primary-color {\n  i {\n    color: @ness_color_3;\n  }\n}\n\n",".primary-color i {\n  color: #94a3b8;\n}\n/*# sourceMappingURL=manage-documents.component.css.map */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
